export enum EImageSize {
  ORIGIN = '',
  TINY = '_30x30',
  SMALL = '_60x60',
  MEDIUM = '_100x100',
}
